module.exports = __webpack_public_path__ + "img/sp_webview.6d41f034.png";